import { Cable, Building2, Wrench } from "lucide-react";
import { positioning } from "@/content/siteContent";
import { SectionHeading } from "./SectionHeading";
import { Medallion } from "./Medallion";
import { Reveal } from "./Reveal";

const icons = [Cable, Building2, Wrench];

export default function Positioning() {
  return (
    <section className="honeycomb bg-ink py-24 md:py-32" data-testid="positioning-section">
      <div className="relative z-10 mx-auto max-w-7xl px-5 md:px-8">
        <SectionHeading
          chapter={positioning.chapter}
          microtitle={positioning.microtitle}
          titleA={positioning.titleA}
          titleB={positioning.titleB}
          highlightWord={positioning.highlightWord}
          description={positioning.description}
        />

        <div className="grid gap-6 md:grid-cols-3">
          {positioning.cards.map((card, i) => (
            <Reveal key={card.num} delay={i * 0.12}>
              <article
                className="card-industrial group overflow-hidden"
                data-testid={`positioning-card-${card.num}`}
              >
                <div className="relative h-56 overflow-hidden">
                  <img
                    src={card.img}
                    alt={card.title}
                    loading="lazy"
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.03]"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-graphite via-transparent to-transparent" />
                  <span className="metal-number absolute right-5 top-4 text-5xl">{card.num}</span>
                </div>
                <div className="relative p-7 pt-0">
                  <div className="-mt-9 mb-5">
                    <Medallion icon={icons[i]} size={72} testId={`positioning-medallion-${card.num}`} />
                  </div>
                  <h3 className="font-display text-xl font-extrabold tracking-wide text-paper">{card.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-mist">{card.desc}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
